interface FormatRouteOptions {
  routeParams?: Record<string, string>;
  queryParams?: Record<string, string>;
}

/**
 * Formats a given page route by replacing route parameters and appending query parameters.
 *
 * @param path - The route path with optional :param placeholders.
 * @param options - Optional route and query parameters.
 * @returns The formatted path with substituted route params and appended query string.
 */
export const formatRoute = (
  path: string,
  { routeParams, queryParams }: FormatRouteOptions = {},
): string => {
  let formattedPath = path;
  if (routeParams) {
    formattedPath = path.replace(/:([^/?&#]+)/g, (match, paramName) => {
      return routeParams[paramName] !== undefined
        ? encodeURIComponent(routeParams[paramName])
        : match;
    });
  }

  const searchParams = new URLSearchParams(queryParams).toString();
  if (searchParams) {
    const hasQueryAlready = formattedPath.includes("?");
    formattedPath += (hasQueryAlready ? "&" : "?") + searchParams;
  }

  return formattedPath;
};
